import { SafeHtml } from '@angular/platform-browser'
import { PolicyInitiativeModel } from '../../../../resources/policy-initiative/models/policy-initiative.model'

export type PolicyInitiativeStep = 1 | 2 | 3

export type PolicyInitiativeView = {
  key: keyof PolicyInitiativeModel
  label: string
  value:
    | string
    | string[]
    | number
    | boolean
    | Date
    | null
    | undefined
    | { name: string; path: string }[]
    | SafeHtml
  type: 'text' | 'date' | 'link' | 'image' | 'files' | 'richText'
  step: PolicyInitiativeStep
  mainProperty?: string
  secondaryProperty?: string
  multiValue?: boolean
}

export type PolicyInitiativeFieldViewConfig = {
  type: PolicyInitiativeView['type']
  transform: (value: any) => PolicyInitiativeView['value']
  multiValue?: boolean
  mainProperty?: string
  secondaryProperty?: string
}

export const POLICY_INITIATIVE_FIELD_VIEW_CONFIG: Record<
  string,
  PolicyInitiativeFieldViewConfig
> = {
  // Text Arrays (extracting .name)
  principles: {
    type: 'text',
    multiValue: true,
    transform: (v: any[]) => v.map((item) => item.name)
  },
  targetSectors: {
    type: 'text',
    multiValue: true,
    transform: (v: any[]) => v.map((item) => item.name)
  },
  tags: {
    type: 'text',
    multiValue: true,
    transform: (v: any[]) => v.map((item) => item.name)
  },
  engagementMechanisms: {
    type: 'text',
    multiValue: true,
    transform: (v: any[]) => v.map((item) => item.name)
  },

  // Single Object Names
  intergovernmentalOrganisation: {
    type: 'text',
    transform: (v: any) => v.name
  },
  gaiinCountry: {
    type: 'text',
    transform: (v: any) => v.name
  },
  initiativeType: {
    type: 'text',
    transform: (v: any) => v.name
  },

  // Links
  videoUrl: {
    type: 'link',
    multiValue: false,
    transform: (v: string) => v
  },
  evaluationUrls: {
    type: 'link',
    multiValue: true,
    transform: (v: any[]) => v // Assuming array of strings/links
  },
  relevantUrls: {
    type: 'link',
    multiValue: true,
    transform: (v: any[]) => v
  },

  // Files
  evaluationFiles: {
    type: 'files',
    multiValue: true,
    mainProperty: 'name',
    secondaryProperty: 'path',
    transform: (v: any[]) =>
      v.map((item) => ({ name: item.name, path: item.path }))
  },
  sourceFiles: {
    type: 'files',
    multiValue: true,
    mainProperty: 'name',
    secondaryProperty: 'path',
    transform: (v: any[]) =>
      v.map((item) => ({ name: item.name, path: item.path }))
  },
  relevantFiles: {
    type: 'files',
    multiValue: true,
    mainProperty: 'name',
    secondaryProperty: 'path',
    transform: (v: any[]) =>
      v.map((item) => ({ name: item.name, path: item.path }))
  },

  // Images
  images: {
    type: 'image',
    multiValue: true,
    transform: (v: any[]) => v.map((item) => item.path)
  },

  // Rich Text
  overview: {
    type: 'richText',
    transform: (v: any) => v
  }
}
